import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-sequence-badge',
  templateUrl: './sequence-badge.component.html',
  styleUrls: ['./sequence-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SequenceBadgeComponent {
  @Input() color: string = "#ec6726";
  @Input() index: number;
}
